<div class="content content-more-margin desktop-wide">
  @if (!showUSCountryPage() && !showLatamCountryPage()) {
    <div>
      <h1 class="center">
        {{ i18n.langString("service_conditions_new_title") }}
      </h1>
      <h1 class="center" style="margin: 0px !important">
        {{ i18n.langString("service_conditions_new_subtitle") }}
      </h1>
      <h3>{{ i18n.langString("service_scope_1") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_1_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_1_2_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_1_3_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_1_4_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_1_5_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_1_6_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_1_7_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_1_8_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_1_9_content')"></p>
      <div style="width: 40%; border: 1px solid #000; margin-bottom: 8px"></div>
      <p [innerHTML]="i18n.langString('service_scope_1_9_below_content')"></p>
      <h3>{{ i18n.langString("service_scope_2") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_2_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_2_2_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_2_3_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_2_4_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_2_5_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_2_6_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_2_7_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_2_8_content')"></p>
      <h3>{{ i18n.langString("service_scope_3") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_3_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_3_2_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_3_3_content')"></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_3_1_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_3_2_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_3_3_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_3_4_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_3_5_content')"
        class="mar-left"
      ></p>
      <p [innerHTML]="i18n.langString('service_scope_3_4_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_3_5_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_3_6_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_3_7_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_3_8_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_3_9_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_3_10_content')"></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_10_1_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_10_2_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_10_3_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_10_4_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_10_5_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_10_6_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_10_7_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_10_8_content')"
        class="mar-left"
      ></p>
      <h3>{{ i18n.langString("service_scope_4") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_4_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_4_2_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_4_3_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_4_4_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_4_5_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_4_6_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_4_7_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_4_8_content')"></p>
      <h3>{{ i18n.langString("service_scope_5") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_5_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_5_2_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_5_3_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_5_4_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_5_5_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_5_6_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_5_7_content')"></p>
      <h3>{{ i18n.langString("service_scope_6") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_6_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_6_2_content')"></p>
      <h3>{{ i18n.langString("service_scope_7") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_7_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_7_2_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_7_3_content')"></p>
      <h3>{{ i18n.langString("service_scope_8") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_8_1_content')"></p>
      <p
        [innerHTML]="i18n.langString('service_scope_8_1_1_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_8_1_2_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_8_1_3_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_8_1_4_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_8_1_5_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_8_1_6_content')"
        class="mar-left"
      ></p>
      <p [innerHTML]="i18n.langString('service_scope_8_2_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_8_3_content')"></p>
      <h3>{{ i18n.langString("service_scope_9") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_9_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_9_2_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_9_3_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_9_4_content')"></p>
      <p
        [innerHTML]="i18n.langString('service_scope_9_4_1_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_9_4_2_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_9_4_3_content')"
        class="mar-left"
      ></p>
      <p [innerHTML]="i18n.langString('service_scope_9_5_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_9_6_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_9_7_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_9_8_content')"></p>
      <h3>{{ i18n.langString("service_scope_10") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_10_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_10_2_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_10_3_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_10_4_content')"></p>
      <h3>{{ i18n.langString("service_scope_11") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_11_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_11_2_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_11_3_content')"></p>
      <h3>{{ i18n.langString("service_scope_12") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_12_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_12_2_content')"></p>
      <p
        [innerHTML]="i18n.langString('service_scope_12_2_1_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_12_2_2_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_12_2_3_content')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_12_2_4_content')"
        class="mar-left"
      ></p>
      <p [innerHTML]="i18n.langString('service_scope_12_3_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_12_4_content')"></p>
      <h3>{{ i18n.langString("service_scope_13") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_13_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_13_2_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_13_3_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_13_4_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_13_5_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_13_6_content')"></p>
      <h3>{{ i18n.langString("service_scope_14") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_14_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_14_2_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_14_3_content')"></p>
      <h3>{{ i18n.langString("service_scope_15") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_15_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_15_2_content')"></p>
      <h3>{{ i18n.langString("service_scope_16") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_16_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_16_2_content')"></p>
      <h3>{{ i18n.langString("service_scope_17") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_17_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_17_2_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_17_3_content')"></p>
      <h3>{{ i18n.langString("service_scope_18") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_18_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_18_2_content')"></p>
      <h3>{{ i18n.langString("service_scope_19") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_19_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_19_2_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_19_3_content')"></p>
      <h3>{{ i18n.langString("service_scope_20") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_20_1_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_20_2_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_20_3_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_20_4_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_20_5_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_20_6_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_20_7_content')"></p>
      <p [innerHTML]="i18n.langString('service_scope_20_8_content')"></p>
      <h2 class="center" style="margin-top: 50px">
        {{ i18n.langString("service_scope_annex_1") }}
      </h2>
      <h3 class="center" style="margin: 0px !important">
        {{ i18n.langString("service_scope_specific_terms") }}
      </h3>
      <p style="margin: 20px; font-size: 23px">
        {{ i18n.langString("service_scope_loctite") }}
      </p>
      <p
        style="margin-top: 20px"
        [innerHTML]="i18n.langString('service_scope_loctite_1')"
      ></p>
      <p [innerHTML]="i18n.langString('service_scope_loctite_2')"></p>
      <p [innerHTML]="i18n.langString('service_scope_loctite_3')"></p>
      <p [innerHTML]="i18n.langString('service_scope_loctite_4')"></p>
      <p [innerHTML]="i18n.langString('service_scope_loctite_5')"></p>
      <p
        [innerHTML]="i18n.langString('service_scope_loctite_5_1')"
        class="mar-left"
      ></p>
      <p [innerHTML]="i18n.langString('service_scope_loctite_5_1_content')"></p>
      <p
        [innerHTML]="i18n.langString('service_scope_loctite_5_2')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_loctite_5_3')"
        class="mar-left"
      ></p>
      <p [innerHTML]="i18n.langString('service_scope_loctite_6')"></p>
      <p [innerHTML]="i18n.langString('service_scope_loctite_7')"></p>
      <p
        style="margin-top: 20px"
        [innerHTML]="i18n.langString('service_scope_loctite_content')"
      ></p>
      <h2 class="center" style="margin-top: 50px">
        {{ i18n.langString("service_scope_annex_2") }}
      </h2>
      <h3 class="center" style="margin: 0px !important">
        {{ i18n.langString("service_scope_annex_list") }}
      </h3>
      <p
        style="margin-top: 20px"
        [innerHTML]="i18n.langString('service_scope_annex_list_1')"
      ></p>
      <p [innerHTML]="i18n.langString('service_scope_annex_list_2')"></p>
      <p [innerHTML]="i18n.langString('service_scope_annex_list_3')"></p>
      <p [innerHTML]="i18n.langString('service_scope_annex_list_4')"></p>
      <p [innerHTML]="i18n.langString('service_scope_annex_list_5')"></p>
      <p [innerHTML]="i18n.langString('service_scope_annex_list_6')"></p>
      <p [innerHTML]="i18n.langString('service_scope_annex_list_7')"></p>
      <h2 class="center" style="margin-top: 50px">
        {{ i18n.langString("service_scope_annex_3") }}
      </h2>
      <h3 class="center" style="margin: 0px !important">
        {{ i18n.langString("service_scope_Model_terms") }}
      </h3>
      <h4 class="center" style="margin: 0px !important">
        {{ i18n.langString("service_scope_annex3_subheader") }}
      </h4>

      <h3 style="margin-top: 20px">
        {{ i18n.langString("service_scope_annex3_1") }}
      </h3>
      <p
        style="margin-top: 12px; font-size: 22px"
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_1_1')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_1_1_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_1_1_content_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_1_1_content_2')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_1_1_content_3')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_1_1_content_4')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_1_1_content_5')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_1_1_content_6')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_1_1_content_7')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_1_1_content_8')"
      ></p>
      <p
        style="margin-top: 12px; font-size: 22px"
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_1_2')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_1_2_content')"
      ></p>
      <div style="width: 40%; border: 1px solid #000; margin-bottom: 8px"></div>
      <p
        [innerHTML]="i18n.langString('service_scope_annex3_1_2_below_content')"
      ></p>
      <p
        style="margin-top: 12px; font-size: 22px"
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_1_3')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_1_3_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_1_3_content_a')"
      ></p>
      <div class="table-wrap">
        <table aria-label="LOCTITE Pulse Products">
          <thead>
            <tr>
              <th scope="col">LOCTITE Pulse Product</th>
              <th scope="col">IDH</th>
              <th scope="col">HENKEL IDH Name</th>
            </tr>
          </thead>
          <tbody>
            <!-- Smart Flange -->
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Flange</span>
              </td>
              <td data-label="IDH">2821468</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE SE 1000 LD 500mm
              </td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Flange</span>
              </td>
              <td data-label="IDH">2821467</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE SE 1000 LD 300mm
              </td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Flange</span>
              </td>
              <td data-label="IDH">3055993</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE SE 2000 LD 500MM HT
              </td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Flange</span>
              </td>
              <td data-label="IDH">3056784</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE SE 2000 LD 300MM HT
              </td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Flange</span>
              </td>
              <td data-label="IDH">2821466</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE AC 100 Extender 5m
              </td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Flange</span>
              </td>
              <td data-label="IDH">2821465</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE AC 200 Junct Box
              </td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Flange</span>
              </td>
              <td data-label="IDH">2821464</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE ED 10 Edge Device
              </td>
            </tr>

            <!-- Smart Rotating -->
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Rotating</span>
              </td>
              <td data-label="IDH">2959906</td>
              <td data-label="HENKEL IDH Name">Loctite Pulse MH 2000 EX2</td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Rotating</span>
              </td>
              <td data-label="IDH">2959911</td>
              <td data-label="HENKEL IDH Name">Loctite Pulse MH 1000 EX2</td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Rotating</span>
              </td>
              <td data-label="IDH">2959907</td>
              <td data-label="HENKEL IDH Name">Loctite Pulse MH 2000 EX0 EU</td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Rotating</span>
              </td>
              <td data-label="IDH">2959908</td>
              <td data-label="HENKEL IDH Name">Loctite Pulse MH 1000 EX0 EU</td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Rotating</span>
              </td>
              <td data-label="IDH">2959909</td>
              <td data-label="HENKEL IDH Name">Loctite Pulse AC 301 4pk</td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Rotating</span>
              </td>
              <td data-label="IDH">2959910</td>
              <td data-label="HENKEL IDH Name">Loctite Pulse AC 300 10pk</td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Rotating</span>
              </td>
              <td data-label="IDH">2959921</td>
              <td data-label="HENKEL IDH Name">Loctite Pulse AC 302 10pk</td>
            </tr>

            <!-- Smart Steam Trap -->
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Steam Trap</span>
              </td>
              <td data-label="IDH">2907673</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE SE 1000 DD Temp
              </td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Steam Trap</span>
              </td>
              <td data-label="IDH">2907677</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE ED 10 DAU TC HH EX
              </td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Steam Trap</span>
              </td>
              <td data-label="IDH">2907699</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE ED 100 DAU DD HH EX
              </td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Steam Trap</span>
              </td>
              <td data-label="IDH">2907711</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE ED 100 DAU DD HH
              </td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Steam Trap</span>
              </td>
              <td data-label="IDH">2907713</td>
              <td data-label="HENKEL IDH Name">LOCTITE PULSE ED 10 GW DD EX</td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Steam Trap</span>
              </td>
              <td data-label="IDH">2907715</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE AC DD Power Supply EX
              </td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Steam Trap</span>
              </td>
              <td data-label="IDH">2907716</td>
              <td data-label="HENKEL IDH Name">LOCTITE PULSE ED 20 GW NA</td>
            </tr>

            <!-- Smart Steam Trap / Smart Valve -->
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Steam Trap / Smart Valve</span>
              </td>
              <td data-label="IDH">2907712</td>
              <td data-label="HENKEL IDH Name">LOCTITE PULSE ED 20 GW EU</td>
            </tr>

            <!-- Smart Valve -->
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Valve</span>
              </td>
              <td data-label="IDH">2907693</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE ED 10 DAU TC HL EX
              </td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Rotating</span>
              </td>
              <td data-label="IDH">3091366</td>
              <td data-label="HENKEL IDH Name">Loctite Pulse AC 303 4pk</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_1_3_content_b')"
      ></p>
      <div class="table-wrap">
        <table aria-label="LOCTITE Pulse Products">
          <thead>
            <tr>
              <th scope="col">LOCTITE Pulse Product</th>
              <th scope="col">IDH</th>
              <th scope="col">HENKEL IDH Name</th>
            </tr>
          </thead>
          <tbody>
            <!-- Smart Flange -->
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Flange</span>
              </td>
              <td data-label="IDH">2827043</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE SV LD Flange Subscr
              </td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Flange</span>
              </td>
              <td data-label="IDH">2827044</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE SV LD Pipe Subscr
              </td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Steam Trap</span>
              </td>
              <td data-label="IDH">2899827</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE SV DD Stmtrap Sbsc
              </td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Valve</span>
              </td>
              <td data-label="IDH">2899828</td>
              <td data-label="HENKEL IDH Name">
                LOCTITE PULSE SV DD Valve Sbsc
              </td>
            </tr>
            <tr>
              <td data-label="LOCTITE Pulse Product">
                <span class="badge">Smart Rotating</span>
              </td>
              <td data-label="IDH">2970160</td>
              <td data-label="HENKEL IDH Name">LOCTITE Pulse MH SBSC</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p
        class="mar-left"
        [innerHTML]="
          i18n.langString('service_scope_annex3_1_3_content_b_extension')
        "
      ></p>
      <h3 style="margin-top: 20px">
        {{ i18n.langString("service_scope_annex3_2") }}
      </h3>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_2_1_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_2_2_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_2_3_content')"
      ></p>
      <h3 style="margin-top: 20px">
        {{ i18n.langString("service_scope_annex3_3") }}
      </h3>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 8px; font-size: 20px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_1_1')"
      ></p>
      <p
        class="mar-left"
        style="padding-left: 16px"
        [innerHTML]="i18n.langString('service_scope_annex3_1_1_a_content')"
      ></p>
      <p
        class="mar-left"
        style="padding-left: 16px"
        [innerHTML]="i18n.langString('service_scope_annex3_1_1_b_content')"
      ></p>
      <p
        class="mar-left"
        style="padding-left: 16px"
        [innerHTML]="i18n.langString('service_scope_annex3_1_1_c_content')"
      ></p>
      <p
        class="mar-left"
        style="padding-left: 16px"
        [innerHTML]="i18n.langString('service_scope_annex3_1_1_d_content')"
      ></p>
      <p
        style="padding-left: 16px"
        class="mar-left"
        [innerHTML]="i18n.langString('service_scope_annex3_1_1_e_content')"
      ></p>
      <p
        class="mar-left"
        style="padding-left: 16px"
        [innerHTML]="i18n.langString('service_scope_annex3_1_1_f_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 8px; font-size: 20px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_1_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_1_2_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 8px; font-size: 20px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_2_1')"
      ></p>
      <p
        class="mar-left"
        style="padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_2_1_a')"
      ></p>
      <p
        class="mar-left"
        style="padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_2_1_a_1')"
      ></p>
      <p
        class="mar-left"
        style="padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_2_1_a_2')"
      ></p>
      <p
        class="mar-left"
        style="padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_2_1_a_3')"
      ></p>
      <p
        class="mar-left"
        style="padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_2_1_b')"
      ></p>
      <p
        class="mar-left"
        style="padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_2_1_b_1')"
      ></p>
      <p
        class="mar-left"
        style="padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_2_1_b_2')"
      ></p>
      <p
        class="mar-left"
        style="padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_2_1_b_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 8px; font-size: 20px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_2_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_3_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_4')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_4_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_4_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_3_4_3')"
      ></p>
      <h3 style="margin-top: 20px">
        {{ i18n.langString("service_scope_annex3_4") }}
      </h3>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_1_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_1_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_2_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_2_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_2_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_2_4')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_2_4_part2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_2_5')"
      ></p>
      <p
        class="mar-left"
        style="padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_2_5_a')"
      ></p>
      <p
        class="mar-left"
        style="padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_2_5_b')"
      ></p>
      <p
        class="mar-left"
        style="padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_2_5_c')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_3_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_3_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_4')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_4_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_4_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 18px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_4_2_a')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 18px"
        [innerHTML]="i18n.langString('service_scope_annex3_4_4_2_b')"
      ></p>
      <h3 style="margin-top: 20px">
        {{ i18n.langString("service_scope_annex3_5") }}
      </h3>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_1_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_1_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_2_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_2_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_2_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_2_3_extension')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_3_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_3_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_3_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_4')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_4_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_4_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_4_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_4_4_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_4_4_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_4_4_2_a')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_4_4_2_b')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_4_4_2_c')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_5')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_5_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_5_a')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_5_b')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_5_c')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_6')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_6_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_6_1_a')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_6_1_b')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 24px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_6_1_extension')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_5_6_2')"
      ></p>
      <h3 style="margin-top: 20px">
        {{ i18n.langString("service_scope_annex3_6") }}
      </h3>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_6_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_6_1_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_6_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_6_2_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_6_2_content_a')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_6_2_content_b')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_6_2_content_c')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_6_2_content_d')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_6_2_content_e')"
      ></p>
      <h3 style="margin-top: 20px">
        {{ i18n.langString("service_scope_annex3_7") }}
      </h3>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_7_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_7_1_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_7_1_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_7_1_2_extension')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_7_1_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_7_1_4')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_7_1_5')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_7_1_6')"
      ></p>
      <h3 style="margin-top: 20px">
        {{ i18n.langString("service_scope_annex3_8") }}
      </h3>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_8_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_8_1_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_8_1_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_8_1_2_a')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_8_1_2_b')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_8_1_2_c')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_8_1_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_8_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_8_2_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_8_2_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_8_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_8_3_content')"
      ></p>
      <h3 style="margin-top: 20px">
        {{ i18n.langString("service_scope_annex3_9") }}
      </h3>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_9_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_9_1_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_9_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_9_2_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_9_2_1_a')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_9_2_1_b')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_9_2_1_c')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_9_2_1_extension')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_9_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_9_3_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_9_3_1_extension')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_9_3_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_9_3_2_a')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_9_3_2_b')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_9_3_3')"
      ></p>
      <h3 style="margin-top: 20px">
        {{ i18n.langString("service_scope_annex3_10") }}
      </h3>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_10_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_10_1_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_10_1_1_a')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_10_1_1_b')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_10_1_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_10_1_2_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_10_1_2_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_10_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_10_2_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_10_2_1_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_10_2_1_2')"
      ></p>
      <h3 style="margin-top: 20px">
        {{ i18n.langString("service_scope_annex3_11") }}
      </h3>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_1_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_1_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_1_2_a')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_1_2_b')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_1_2_c')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_1_2_d')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_1_2_e')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_1_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_1_3_a')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_1_3_b')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_1_3_c')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_1_4')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_1_5')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_2_content1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_2_content2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_2_a')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_2_b')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_2_c')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_3_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_4')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_4_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_4_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_4_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_5')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_5_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_5_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_6')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_annex3_11_6_1')"
      ></p>
      <h4 class="center" style="margin-top: 12px">
        {{ i18n.langString("service_scope_appendix1_subheader") }}
      </h4>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_appendix1_a')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_a_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 20px; color: midnightblue"
        [innerHTML]="i18n.langString('service_scope_appendix1_Master')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_Master_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="
          i18n.langString('service_scope_appendix1_Master_content_a')
        "
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="
          i18n.langString('service_scope_appendix1_Master_content_b')
        "
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="
          i18n.langString('service_scope_appendix1_Master_content_c')
        "
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 20px; color: midnightblue"
        [innerHTML]="i18n.langString('service_scope_appendix1_raw')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_raw_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_raw_content_a')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_raw_content_b')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_raw_content_c')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_raw_content_d')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_raw_content_e')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_raw_content_f')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 20px; color: midnightblue"
        [innerHTML]="i18n.langString('service_scope_appendix1_analysed')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px"
        [innerHTML]="
          i18n.langString('service_scope_appendix1_analysed_content')
        "
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="
          i18n.langString('service_scope_appendix1_analysed_content_a')
        "
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="
          i18n.langString('service_scope_appendix1_analysed_content_b')
        "
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="
          i18n.langString('service_scope_appendix1_analysed_content_c')
        "
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 20px; color: midnightblue"
        [innerHTML]="i18n.langString('service_scope_appendix1_pii')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_pii_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_pii_content_a')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_pii_content_b')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_pii_content_c')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_pii_content_d')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_pii_content_e')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_pii_content_f')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_pii_content_g')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_pii_content_h')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_pii_content_i')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_appendix1_b')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_b_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_appendix1_c')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_c_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix1_c_content_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix1_c_content_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix1_c_content_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix1_c_content_4')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_appendix1_d')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_d_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_appendix1_e')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_e_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix1_e_content_1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix1_e_content_2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix1_e_content_3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_appendix1_f')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_f_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_appendix1_g')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix1_g_content')"
      ></p>
      <h4 class="center" style="margin-top: 12px">
        {{ i18n.langString("service_scope_appendix2_subheader") }}
      </h4>
      <div class="center" style="margin-top: 12px">
        <table class="appendix-table">
          <tr>
            <th>Identification of the User</th>
            <td>
              Name: <i>Specify</i><br /><br />
              Contract n°: <i>Specify</i>
            </td>
          </tr>

          <tr>
            <th>
              Identification of the person making the request on behalf of the
              User (if applicable)
            </th>
            <td>
              Name: <i>Specify</i><br /><br />
              Relationship with the User: <i>Specify</i>
            </td>
          </tr>

          <tr>
            <th>Products and/or Services concerned by the request</th>
            <td>
              Product/Service 1: <i>Specify (e.g. serial number)</i><br /><br />
              Product/Service 2: <i>Specify (e.g. serial number)</i>
            </td>
          </tr>

          <tr>
            <th>Data points concerned by the request</th>
            <td>
              <!-- Top-level item -->
              <div class="item">
                <label>
                  <span class="cb" style="margin-top: 20px"></span>
                  <span style="margin-top: 16px"
                    >All data which is readily available to the Data
                    Holder</span
                  >
                </label>
              </div>

              <!-- Nested item -->
              <div class="item nested-1">
                <label>
                  <input type="checkbox" class="cb" style="margin-top: 20px" />
                  <span style="margin-top: 16px">Including personal Data</span>
                </label>
              </div>

              <!-- The italic paragraph under “Including personal Data” -->
              <div class="note nested-2">
                <em>
                  If the User is not the data subject, specify valid legal basis
                  for processing under Article 6 of Regulation (EU) 2016/679
                  and, where relevant, how the conditions of Article 9 of that
                  Regulation and of Article 5(3) of Directive 2002/58/EC are
                  fulfilled
                </em>
              </div>

              <!-- Next nested item (same level as “Including personal Data”) -->
              <div class="item nested-1">
                <label>
                  <input type="checkbox" class="cb" style="margin-top: 20px" />
                  <span style="margin-top: 16px">After anonymization</span>
                </label>
              </div>

              <!-- Back to top level -->
              <div class="item">
                <label>
                  <input type="checkbox" class="cb" style="margin-top: 20px" />
                  <span style="margin-top: 16px">Only non-personal Data</span>
                </label>
              </div>

              <div class="item">
                <label>
                  <input type="checkbox" class="cb" style="margin-top: 20px" />
                  <span style="margin-top: 16px">Other: <em>Specify</em></span>
                </label>
              </div>
            </td>
          </tr>

          <tr>
            <th>Date of Data concerned by the request</th>
            <td>
              <input type="checkbox" class="cb" style="margin-top: 16px" /> Past
              data: <i>Specify the period</i><br />
              <input type="checkbox" class="cb" style="margin-top: 16px" />
              Future data:
              <i>Specify the period</i>
            </td>
          </tr>

          <tr>
            <th>
              Timing of access to the Data (depending on what is agreed in
              clause 4.3.2)
            </th>
            <td>
              <input type="checkbox" class="cb" /> Continuously<br />
              <input type="checkbox" class="cb" style="margin-top: 16px" />
              Realtime<br />
              <input type="checkbox" class="cb" style="margin-top: 16px" />
              Other:
              <i>Please specify</i>
            </td>
          </tr>

          <tr>
            <th>Modalities for access to the Data</th>
            <td>
              <input type="checkbox" class="cb" /> Transfer of the Data<br />
              <input type="checkbox" class="cb" style="margin-top: 16px" />
              Other:
              <i>Please specify</i>
            </td>
          </tr>

          <tr>
            <th>Destination for the transfer :</th>
            <td>
              <i>Specify depending on the answer to the previous point</i>
            </td>
          </tr>

          <tr>
            <th>Date of the request</th>
            <td>
              <i>Specify</i>
            </td>
          </tr>
        </table>
      </div>
      <h4 class="center" style="margin-top: 12px">
        {{ i18n.langString("service_scope_appendix3_subheader") }}
      </h4>
      <div class="center" style="margin-top: 20px">
        <table class="appendix-table">
          <tr>
            <th>Identification of the User</th>
            <td>
              Name: <i>Specify</i><br /><br />
              Contract n°: <i>Specify</i>
            </td>
          </tr>

          <tr>
            <th>
              Identification of the person making the request on behalf of the
              User (if applicable)
            </th>
            <td>
              Name: <i>Specify</i><br /><br />
              Relationship with the User: <i>Specify</i>
            </td>
          </tr>

          <tr>
            <th>Products and/or Services concerned by the request</th>
            <td>
              Product/Service 1: <i>Specify</i><br /><br />
              Product/Service 2: <i>Specify</i>
            </td>
          </tr>

          <tr>
            <th>
              Data concerned by the request
              <div class="note">
                Please note: does not apply in the context of the testing of new
                connected products, substances or processes that are not yet
                placed on the market
              </div>
            </th>
            <td>
              <input type="checkbox" class="cb" />
              Option 1: All data which is readily available to the Data
              Holder<br /><br />

              <input type="checkbox" class="cb" />
              Option 2:
              <i
                >Specify, in accordance with Appendix 1 of the contract between
                the User and the Data Recipient specifying the Data to be shared
                with the Data Recipient</i
              ><br /><br />

              <input type="checkbox" class="cb" />
              Option 3: As specified by the Data Recipient in appendix 2 of the
              contract between the Data Holder and the Data Recipient
            </td>
          </tr>

          <tr>
            <th>If the data includes personal data</th>
            <td>
              <i>
                Specify valid legal basis for processing under Article 6 of
                Regulation (EU) 2016/679 and, where relevant, how the conditions
                of Article 9 of that Regulation and of Article 5(3) of Directive
                2002/58/EC are fulfilled
              </i>
            </td>
          </tr>

          <tr>
            <th>
              Identification of the third party
              <div class="note">
                Please note: cannot be a gatekeeper under Article 3 of
                Regulation (EU) 2022/1925
              </div>
            </th>
            <td>
              Name: <i>Specify</i><br /><br />
              Contact details: <i>Specify</i>
            </td>
          </tr>
        </table>
      </div>
      <h4 class="center" style="margin-top: 12px">
        {{ i18n.langString("service_scope_appendix4_subheader") }}
      </h4>
      <p
        class="mar-left"
        style="margin-top: 12px; font-size: 22px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content_title')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 12px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content1')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content2')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content3')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content4')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content5')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content6')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content7')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content8')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content9')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content10')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content11')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content12')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content13')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content14')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content15')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content16')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content17')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content18')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content19')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content20')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content21')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content22')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content23')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content24')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content25')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content26')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content27')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content28')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content29')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content30')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content31')"
      ></p>
      <p
        class="mar-left"
        style="margin-top: 12px; padding-left: 20px"
        [innerHTML]="i18n.langString('service_scope_appendix4_content32')"
      ></p>
    </div>
  }
  @if (showLatamCountryPage()) {
    <div>
      <h1 class="center">
        {{ i18n.langString("service_conditions_new_title_latam") }}
      </h1>
      <!-- <h1 class="center" style="margin: 0px">
        {{ i18n.langString("service_conditions_new_subtitle") }}
      </h1> -->
      <h3>{{ i18n.langString("service_scope_1_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_1_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_1_2_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_1_3_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_1_4_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_1_5_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_1_6_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_1_7_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_2_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_2_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_2_2_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_2_3_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_2_4_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_2_5_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_2_6_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_2_7_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_2_8_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_3_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_3_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_3_2_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_3_3_content_latam')"></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_3_1_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_3_2_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_3_3_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_3_4_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_3_5_content_latam')"
        class="mar-left"
      ></p>
      <p [innerHTML]="i18n.langString('service_scope_3_4_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_3_5_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_3_6_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_3_7_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_3_8_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_3_9_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_3_10_content_latam')"></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_10_1_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_10_2_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_10_3_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_10_4_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_10_5_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_10_6_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_10_7_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_3_10_8_content_latam')"
        class="mar-left"
      ></p>
      <h3>{{ i18n.langString("service_scope_4_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_4_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_4_2_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_4_3_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_4_4_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_4_5_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_4_6_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_4_7_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_4_8_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_5_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_5_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_5_2_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_5_3_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_5_4_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_5_5_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_5_6_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_6_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_6_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_6_2_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_7_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_7_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_7_2_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_7_3_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_8_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_8_1_content_latam')"></p>
      <p
        [innerHTML]="i18n.langString('service_scope_8_1_1_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_8_1_2_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_8_1_3_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_8_1_4_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_8_1_5_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_8_1_6_content_latam')"
        class="mar-left"
      ></p>
      <p [innerHTML]="i18n.langString('service_scope_8_2_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_8_3_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_9_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_9_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_9_2_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_9_3_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_9_4_content_latam')"></p>
      <p
        [innerHTML]="i18n.langString('service_scope_9_4_1_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_9_4_2_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_9_4_3_content_latam')"
        class="mar-left"
      ></p>
      <p [innerHTML]="i18n.langString('service_scope_9_5_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_9_6_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_9_7_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_9_8_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_10_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_10_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_10_2_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_10_3_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_10_4_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_11_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_11_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_11_2_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_11_3_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_12_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_12_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_12_2_content_latam')"></p>
      <p
        [innerHTML]="i18n.langString('service_scope_12_2_1_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_12_2_2_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_12_2_3_content_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_12_2_4_content_latam')"
        class="mar-left"
      ></p>
      <p [innerHTML]="i18n.langString('service_scope_12_3_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_12_4_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_13_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_13_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_13_2_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_13_3_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_13_4_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_13_5_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_13_6_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_14_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_14_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_14_2_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_14_3_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_15_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_15_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_15_2_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_16_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_16_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_16_2_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_17_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_17_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_17_2_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_17_3_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_18_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_18_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_18_2_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_19_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_19_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_19_2_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_19_3_content_latam')"></p>
      <h3>{{ i18n.langString("service_scope_20_latam") }}</h3>
      <p [innerHTML]="i18n.langString('service_scope_20_1_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_20_2_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_20_3_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_20_4_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_20_5_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_20_6_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_20_7_content_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_20_8_content_latam')"></p>

      <h2 class="center" style="margin-top: 50px">
        {{ i18n.langString("service_scope_annex_1_latam") }}
      </h2>
      <h3 class="center" style="margin: 0px !important">
        {{ i18n.langString("service_scope_specific_terms_latam") }}
      </h3>
      <p class="center" style="margin: 20px; font-size: 23px">
        {{ i18n.langString("service_scope_loctite_latam") }}
      </p>
      <p
        style="margin-top: 20px"
        [innerHTML]="i18n.langString('service_scope_loctite_1_latam')"
      ></p>
      <p [innerHTML]="i18n.langString('service_scope_loctite_2_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_loctite_3_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_loctite_4_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_loctite_5_latam')"></p>
      <p
        [innerHTML]="i18n.langString('service_scope_loctite_5_1_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_loctite_5_1_content_latam')"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_loctite_5_2_latam')"
        class="mar-left"
      ></p>
      <p
        [innerHTML]="i18n.langString('service_scope_loctite_5_3_latam')"
        class="mar-left"
      ></p>
      <p [innerHTML]="i18n.langString('service_scope_loctite_6_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_loctite_7_latam')"></p>
      <p
        style="margin-top: 20px"
        [innerHTML]="i18n.langString('service_scope_loctite_content_latam')"
      ></p>
      <h2 class="center" style="margin-top: 50px">
        {{ i18n.langString("service_scope_annex_latam") }}
      </h2>
      <h3 class="center" style="margin: 0px !important">
        {{ i18n.langString("service_scope_annex_list_latam") }}
      </h3>
      <p
        style="margin-top: 20px"
        [innerHTML]="i18n.langString('service_scope_annex_list_1_latam')"
      ></p>
      <p [innerHTML]="i18n.langString('service_scope_annex_list_2_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_annex_list_3_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_annex_list_4_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_annex_list_5_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_annex_list_6_latam')"></p>
      <p [innerHTML]="i18n.langString('service_scope_annex_list_7_latam')"></p>
    </div>
  }
  <div>
    <app-nav-button
      [svgIcon]="'icons:arrow-left'"
      [darksecondary]="true"
      class="back-btn"
      (clickEvent)="gotoLogin()"
      >{{ i18n.langString("back") }}
    </app-nav-button>
  </div>

  <app-scroll-to-top></app-scroll-to-top>
</div>
